(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  window.onload = function () {
    const links = document.querySelectorAll('.footer-links');
    links.forEach((link) => {
      link.addEventListener('click', function () {
        const ul = this.nextElementSibling;
        const toggle = this.querySelector('.footer-links-toggle');
        const fire = this.querySelector('.footer-links .fire');
        const washing = this.querySelector('.footer-links .washing');
        if (ul) {
          if (ul.style.maxHeight === '0px' || ul.style.maxHeight === '') {
            ul.style.maxHeight = ul.scrollHeight + 'px'; // 下に開く
            toggle.classList.add('rotate-180');
            fire.classList.add('hidden');
            washing.classList.remove('hidden');
          } else {
            ul.style.maxHeight = ' 0px '; // 閉じる
            toggle.classList.remove('rotate-180');
            fire.classList.remove('hidden');
            washing.classList.add('hidden');
          }
        }
      });
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const menuDrawerButton = document.getElementById('menu-drawer-button');
    const menuDrawer = document.getElementById('menu-drawer');

    if (!menuDrawerButton || !menuDrawer) return;

    menuDrawerButton.addEventListener('click', function () {
      console.log('click');
      this.classList.toggle('-rotate-45');
      menuDrawer.classList.toggle('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-hero"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const heroImage = document.querySelector('#hero-image');
    setTimeout(() => {
      heroImage.style.opacity = 1;
    }, 500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-faq"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const questions = document.querySelectorAll('.faq-content dt');
    questions.forEach((question) => {
      question.addEventListener('click', function () {
        question.classList.toggle('open');
        const answer = question.nextElementSibling;
        if (question.classList.contains('open')) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        } else {
          answer.style.maxHeight = '0px';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#RegisterForm');
    const birthdayYearInput = document.getElementById('RegisterForm-birthday-year');
    const birthdayMonthInput = document.getElementById('RegisterForm-birthday-month');
    const birthdayDayInput = document.getElementById('RegisterForm-birthday-day');
    const birthdayHiddenInput = document.getElementById('birthday-note');

// 全角を半角に変換する関数
    function convertToHalfWidth(str) {
      return str.replace(/[０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
      });
    }

// フォーカス移動の処理
    birthdayYearInput.addEventListener('input', function() {
      if (this.value.length === 4) {
        birthdayMonthInput.focus();
      }
    });

    birthdayMonthInput.addEventListener('input', function() {

// 1~12までしか入力できないようにする
      if (this.value.length === 2 && this.value > 12) {
        this.value = '12';
      }
      if (this.value.length === 2) {
        birthdayDayInput.focus();
      }
    });

    birthdayDayInput.addEventListener('input', function() {
      if (this.value.length === 2) {
        birthdayDayInput.blur();
      }
    });

// フォーカスが外れた時に全角から半角に変換し、noteを更新する
    birthdayYearInput.addEventListener('blur', function() {
      this.value = convertToHalfWidth(this.value);
      updateBirthdayNote();
    });

    birthdayMonthInput.addEventListener('blur', function() {
      this.value = convertToHalfWidth(this.value);
      updateBirthdayNote();
    });

    birthdayDayInput.addEventListener('blur', function() {
      this.value = convertToHalfWidth(this.value);
      updateBirthdayNote();
    });

    function formatBirthday(year, month, day) {
      const formattedMonth = month.padStart(2, '0'); // 1 → 01
      const formattedDay = day.padStart(2, '0'); // 2 → 02
      return `${year}-${formattedMonth}-${formattedDay}`;
    }

    function updateBirthdayNote() {
      const year = birthdayYearInput.value.trim();
      const month = birthdayMonthInput.value.trim();
      const day = birthdayDayInput.value.trim();
      birthdayHiddenInput.value = `${
        formatBirthday(year, month, day)
      }`;
      console.log('Birthday note updated:', birthdayHiddenInput.value);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
